import React from "react";
import PropTypes from 'prop-types';
import _ from 'lodash';
// import { SortableElement } from 'react-sortable-hoc';
import RoomModule from 'modules/room';
import { roomItem as strings } from 'ui/constants/strings';

class RoomItem extends React.PureComponent {
  renderRoomName = () => {
    const { family } = this.props;
    return (
      <div className='roomNameContainer'>
        { _.get(family, 'name', '-') }
      </div>
    )
  }

  renderPatientName = () => {
    const { alert, family } = this.props;
    const { gender, patient } = family
    const nameColor = RoomModule.isMale(gender) ? 'malePatient' : ( RoomModule.isFemale(gender) ? 'femalePatient' : '');
    return (
      <div className={`patientNameContainer ${alert ? 'alert' : ''}`}>
        <span className={alert ? 'alert' : nameColor}>
          { patient || '-' }
        </span>
      </div>
    )
  }

  renderRoomStatus = () => {
    const { alert, devices } = this.props;
    const backgroundColor = RoomModule.isLightOn(devices) ? 'lightOn' : 'lightOff';
    const roomStatusIcon = RoomModule.getRoomStatusIcon(devices, alert);
    if (roomStatusIcon === RoomModule.roomStatusIconClass.deviceOffline) {
      return (
        <div className='roomStatusContainer'>
          <div className={`roomStatusWrapper lightOn`}>
            <div
              className={`roomStatusIcon flexCenterCenter ${roomStatusIcon}`}
              dangerouslySetInnerHTML={{__html: strings.textDeviceOffline}}
            >
            </div>
          </div>
        </div>
      )
    }
    switch (roomStatusIcon) {
      case 'pir_true':
        return (
          <div className={`roomStatusContainer ${alert ? 'alert' : ''}`}>
            <div className={`roomStatusWrapper flexRow flexCenterCenter ${alert ? 'alert' : backgroundColor}`}>
              <div className='roomStatusIconSpecial iconEye'></div><div className='roomStatusIconSpecial iconMan'></div>
            </div>
          </div>
        );
      case 'pir_false':
        return (
          <div className={`roomStatusContainer ${alert ? 'alert' : ''}`}>
            <div className={`roomStatusWrapper flexRow flexCenterCenter ${alert ? 'alert' : backgroundColor}`}>
              <div className='roomStatusIconSpecial iconEye'></div><div className='roomStatusIconSpecial'></div>
            </div>
          </div>
        );
      default:
        return (
          <div className={`roomStatusContainer ${alert ? 'alert' : ''}`}>
            <div className={`roomStatusWrapper ${alert ? 'alert' : backgroundColor}`}>
              <div className={`roomStatusIcon ${roomStatusIcon}`}>
              </div>
            </div>
          </div>
        )
    }
  }

  renderColumnData = (icon, text) => {
    if (icon || text) {
      return (
        <div className={'statusDetailItem'}>
          <span className={`statusDetailIcon ${icon ? icon : ''}`}>
          </span>
          <span className='statusDetailText'>
            { text }
          </span>
        </div>
      )
    }
  }

  renderStatusDetail = (displayData, alert) => {
    const {
      iconTL, iconTR, iconBL, iconBR,
      textTL, textTR, textBL, textBR,
      botBarStatus,
    } = displayData;
    const botBarAdditionalClass = alert ? 'alertOn' : ( botBarStatus ? 'warningOn' : 'alertOff' );
    return (
      <div className='statusDetailRow'>
          <div className={`statusDetailColumn ${alert ? 'alert' : 'normalText'}`}>
          { this.renderColumnData(iconTL, textTL) }
          { ' / '}
          { this.renderColumnData(iconTR, textTR) }
        </div>
          <div className={`statusDetailColumn ${botBarAdditionalClass}`}>
          { this.renderColumnData(iconBL, textBL) }
          { this.renderColumnData(iconBR, textBR) }
        </div>
      </div>
    )
  }

  renderStatus = () => {
    const { alert, devices } = this.props;
    const constructDetail = RoomModule.constructStatusDetail(devices, alert);
    return (
      <div className={`statusContainer ${alert ? 'alert' : ''}`}>
        <div className='statusDetail'>
          { this.renderStatusDetail(constructDetail, alert) }
        </div>
      </div>
    )
  }

  render() {
    const { styles, onRoomPress, suiteId } = this.props;
    return(
      <div className='component-room' onClick={() => onRoomPress(suiteId)} style={styles}>
        { this.renderRoomName() }
        { this.renderPatientName() }
        { this.renderRoomStatus() }
        { this.renderStatus() }
      </div>
    )
  }
}

RoomItem.defaultProps = {
  alert: false,
  styles: {},
};

RoomItem.propTypes = {
  suiteId: PropTypes.string.isRequired,
  family: PropTypes.object.isRequired,
  styles: PropTypes.object,
  groupId: PropTypes.string.isRequired,
  onRoomPress: PropTypes.func.isRequired,
};

// export default SortableElement(RoomItem);
export default RoomItem;
